// extracted by mini-css-extract-plugin
export default {"otpGeneratorPage":"style_otpGeneratorPage__nnCYn"};